module.exports = __webpack_public_path__ + "mainassets/img/big-slider-placeholder.212ceb4a.png";